<template>
  <div class="container mt-4">
    <div class="row justify-content-center">
      <div class="col-md-8">
        <h1 class="font-weight-light text-center">
          Attendees for {{ meeting }}
        </h1>
        <div
          class="card bg-light mb-4"
          v-if="user !== null && user.uid == userID"
        >
          <div class="card-body text-center">
            <div class="input-group input-group-lg">
              <input
                type="text"
                placeholder="Search Attendees"
                class="form-control"
                v-model="searchQuery"
                ref="searchQuery"
              />
              <div class="input-group-append">
                <button
                  class="btn btn-sm btn-outline-info"
                  title="Pick a random attendee"
                  @click="pickRandom"
                >
                  <font-awesome-icon icon="random"></font-awesome-icon>
                </button>
                <button
                  class="btn btn-sm btn-outline-info"
                  title="Reset Search"
                  @click="resetSearch"
                >
                  <font-awesome-icon icon="undo"></font-awesome-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-center">
      <div
        class="col-8 col-sm-6 col-md-4 col-lg-3 mb-2 p-0 px-1"
        v-for="item in filteredAttendees"
        :key="item.id"
      >
        <div class="card">
          <div
            class="card-body px-3 py-2 d-flex align-items-center justify-content-center"
            :class="[user !== null && user.uid == userID ? '' : 'bg-light']"
          >
            <div
              class="btn-group pr-2"
              v-if="user !== null && user.uid == userID"
            >
              <button
                class="btn btn-sm btn-outline-info bg-light"
                title="Give user a star"
                @click="toggleStar(item.id)"
              >
                <font-awesome-icon
                  :class="[item.star ? 'text-danger' : '']"
                  icon="star"
                />
              </button>
              <a
                class="btn btn-sm btn-outline-info bg-light"
                title="Send user an email"
                :href="'mailto:' + item.eMail"
              >
                <font-awesome-icon icon="envelope" />
              </a>
              <button
                class="btn btn-sm btn-outline-info bg-light"
                title="Delete Attendee"
                @click="deleteAttendee(item.id)"
              >
                <font-awesome-icon icon="trash" />
              </button>
            </div>
            <div>
              {{ item.displayName }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import db from "@/db.js";
export default {
  name: "attendees",
  components: {
    FontAwesomeIcon
  },
  computed: {
    filteredAttendees: function() {
      const dataFilter = item =>
        item.displayName.toLowerCase().match(this.searchQuery.toLowerCase()) &&
        true;
      return this.displayAttendees.filter(dataFilter);
    }
  },
  data: function() {
    let meetingTitle = "Unknown meeting";
    for (let meet of this.meetings) {
      if (this.$route.params.meetingID == meet.id) {
        meetingTitle =
          meet.name + ", " + meet.date + " @ " + meet.time + ", " + meet.place;
        break;
      }
    }
    return {
      userID: this.$route.params.userID,
      meetingID: this.$route.params.meetingID,
      meeting: meetingTitle,
      searchQuery: "", // Default search is an empty string
      attendees: [],
      displayAttendees: []
    };
  },
  methods: {
    deleteAttendee: function(attendeeID) {
      // Only the user who created the meeting can delete attendees
      if (this.user && this.user.uid == this.userID) {
        db.firestore()
          .collection("users")
          .doc(this.userID)
          .collection("meetings")
          .doc(this.meetingID)
          .collection("attendees")
          .doc(attendeeID)
          .delete();
      }
    },
    pickRandom: function() {
      const randomAttendee = Math.floor(Math.random() * this.attendees.length);
      this.displayAttendees = [this.attendees[randomAttendee]];
    },
    resetSearch: function() {
      this.displayAttendees = this.attendees;
      this.searchQuery = "";
      this.$refs.searchQuery.focus();
    },
    toggleStar: function(attendeeID) {
      // Only the user who created the meeting can toggle stars
      if (this.user && this.user.uid == this.userID) {
        const ref = db
          .firestore()
          .collection("users")
          .doc(this.userID)
          .collection("meetings")
          .doc(this.meetingID)
          .collection("attendees")
          .doc(attendeeID);

        ref.get().then(doc => {
          const star = doc.data().star;
          if (star) {
            ref.update({
              star: !star
            });
          } else {
            ref.update({
              star: true
            });
          }
        });
      }
    }
  },
  mounted() {
    db.firestore()
      .collection("users")
      .doc(this.userID)
      .collection("meetings")
      .doc(this.meetingID)
      .collection("attendees")
      .onSnapshot(snapshot => {
        const tempData = [];
        snapshot.forEach(doc => {
          tempData.push({
            id: doc.id,
            displayName: doc.data().displayName,
            eMail: doc.data().eMail,
            star: doc.data().star
          });
        });
        this.attendees = tempData.sort((a, b) => {
          // Case-insensitive sort by name
          if (a.displayName.toLowerCase() < b.displayName.toLowerCase()) {
            return -1;
          } else {
            return 1;
          }
        });
        this.displayAttendees = this.attendees;
      });
  },
  props: ["user", "meetings"]
};
</script>
